<template>
	<div class="popupCompatibilite">
		<div v-if="processing">
			<LoadingSpinner class="col-12" />
		</div>
		<div v-else>
			<template v-if="criteres_local.length > 2 && stallions_local.length > 0">
				<!-- <b-button v-b-toggle.collpaseNote class="btnNote">
					<h3 ref="title-stallion" class="mb-0">3. {{ $t('pax.résultats') }}</h3>
					<span><font-awesome-icon :icon="['far', 'angle-down']" /></span>
				</b-button>
				<b-collapse visible id="collpaseNote" v-model="show_note">
					<div class="paragraphes">{{ $t('pax.comparer_jusqua_trois_jument_avec_letalon') }}</div>
					<div class="stallionGrade" v-for="stallion in stallions_local" :key="stallion.horse_id" :class="callColorGrade(stallion.horse_id)">
						<div class="row no-gutters align-items-center" @click="displayDetailsCroisement(stallion)">
							<div class="col-5">
								<div class="stallionName">{{ stallion.horse_nom }}</div>
							</div>
							<div class="col-7 text-center">
								<span class="bullet" v-for="critere in criteres_local" :class="getColorBullets(stallion.horse_id, critere.criteres_id)[0]" :key="critere.criteres_id"><font-awesome-icon :icon="['fas', 'circle']"/></span>
							</div>
						</div>
					</div>
					<div class="text-right">
						<button class="btn btn-primary btn-next" @click="showCompatibilite">
							{{ $t('pax.comparer_jusqua_trois_juments') }} <font-awesome-icon :icon="['fal', 'long-arrow-right']" />
						</button>
					</div>
				</b-collapse> -->
				<div>
					<h3 ref="title-stallion" class="mb-0">3. {{ $t('pax.résultats') }}</h3>
					<div class="paragraphes">{{ $t('pax.comparer_jusqua_trois_jument_avec_letalon') }}</div>
					<!-- <div class="stallionGrade" v-for="stallion in stallions_local" :key="stallion.horse_id" :class="callColorGrade(stallion.horse_id)">
						<div class="row no-gutters align-items-center" @click="displayDetailsCroisement(stallion)">
							<div class="col-5">
								<div class="stallionName">{{ stallion.horse_nom }}</div>
							</div>
							<div class="col-7 text-center">
								<span class="bullet" v-for="critere in criteres_local" :class="getColorBullets(stallion.horse_id, critere.criteres_id)[0]" :key="critere.criteres_id"><font-awesome-icon :icon="['fas', 'circle']"/></span>
							</div>
						</div>
					</div> -->

		            <div class="stallionGradeV2" v-for="stallion in stallions_local" :key="stallion.horse_id">
		                <div class="row align-items-center" @click="showCompatibilite">
		                    <div class="col">
		                        <div :class="getGlobalColor(callColorGrade(stallion.horse_id), colorGeneticIndicator(stallion.horse_id))" class="stallionName">{{ stallion.horse_nom }}</div>
		                    </div>
		                    <div class="col-auto">
		                        <div :class="colorGeneticIndicator(stallion.horse_id)"  class="icon_pax"><font-awesome-icon :icon="['fal', 'venus-mars']"/></div>
		                    </div>
		                    <div class="col-auto">
		                        <div :class="callColorGrade(stallion.horse_id)" class="icon_pax"><font-awesome-icon :icon="['cf', 'puzzle']"/></div>
		                    </div>
		                </div>
		            </div>
					<div class="text-right">
						<button class="btn btn-primary btn-next" @click="showCompatibilite">
							{{ $t('pax.comparer_les_juments') }} <font-awesome-icon :icon="['fal', 'long-arrow-right']" />
						</button>
					</div>
				</div>
			</template>
		</div>

		<b-modal dialog-class="modal-pax" ref="modal" hide-footer id="paxModalSelection">
            <template v-slot:modal-title>
                {{ $t("pax.comparer_jusqua_trois_jument_avec_letalon") }}
            </template>

        	<div v-for="(stallion, index) in stallions_selected" class="form-group" :key="'stallion_'+index">
				<label for="season">{{ $t('pax.juments') }} {{ index+1 }}</label>
				<e-select
					v-model="stallions_selected[index]"
					track-by="horse_id"
					label="horse_nom"
					:placeholder="$t('pax.selectionner_une_jument')"
					:options="stallions_selection_modal"
					:allow-empty="false"
					:show-labels="false"
					:sortable="false"
					:searchable="false"
				>
					<template slot="singleLabel" slot-scope="{ option }">
						<!-- <div class="stallionGrade" :key="option.horse_id" :class="callColorGrade(option.horse_id)">
							<div class="row no-gutters align-items-center" >
								<div class="col-5">
									<div class="stallionName">{{ option.horse_nom }}</div>
								</div>
								<div class="col-7 text-center">
									<span class="bullet" v-for="critere in criteres_local" :class="getColorBullets(option.horse_id, critere.criteres_id)[0]" :key="critere.criteres_id"><font-awesome-icon :icon="['fas', 'circle']"/></span>
								</div>
							</div>
						</div> -->
						<div class="stallionGradeV2" :key="option.horse_id">
                            <div class="row align-items-center" @click="showCompatibilite">
                                <div class="col">
                                    <div :class="getGlobalColor(callColorGrade(option.horse_id), colorGeneticIndicator(option.horse_id))"  class="stallionName">{{ option.horse_nom }}</div>
                                </div>
                                <div class="col-auto">
                                    <div :class="callColorGrade(option.horse_id)" class="icon_pax"><font-awesome-icon :icon="['fal', 'venus-mars']"/></div>
                                </div>
                                <div class="col-auto">
                                    <div :class="colorGeneticIndicator(option.horse_id)" class="icon_pax">
                                        <font-awesome-icon :icon="['cf', 'puzzle']"/>
                                    </div>
                                </div>
                            </div>
                        </div>
		            </template>
		            <template slot="option" slot-scope="{ option }">
						<!-- <div class="stallionGrade" :key="option.horse_id" :class="callColorGrade(option.horse_id)">
							<div class="row no-gutters align-items-center" >
								<div class="col-5">
									<div class="stallionName">{{ option.horse_nom }}</div>
								</div>
								<div class="col-7 text-center">
									<span class="bullet" v-for="critere in criteres_local" :class="getColorBullets(option.horse_id, critere.criteres_id)[0]" :key="critere.criteres_id"><font-awesome-icon :icon="['fas', 'circle']"/></span>
								</div>
							</div>
						</div> -->
						<div class="stallionGradeV2" :key="option.horse_id">
                            <div class="row align-items-center" @click="showCompatibilite">
                                <div class="col">
                                    <div :class="getGlobalColor(callColorGrade(option.horse_id), colorGeneticIndicator(option.horse_id))"  class="stallionName">{{ option.horse_nom }}</div>
                                </div>
                                <div class="col-auto">
                                    <div :class="callColorGrade(option.horse_id)" class="icon_pax"><font-awesome-icon :icon="['fal', 'venus-mars']"/></div>
                                </div>
                                <div class="col-auto">
                                    <div :class="colorGeneticIndicator(option.horse_id)" class="icon_pax">
                                        <font-awesome-icon :icon="['cf', 'puzzle']"/>
                                    </div>
                                </div>
                            </div>
                        </div>
		            </template>
					<template slot="noOptions">{{ $t('global.list_empty') }}</template>
				</e-select>
			</div>

			<div class="text-center">
				<button class="btn btn-pax" @click="sendStallionsSelected">{{ $t('pax.comparer') }}</button>
			</div>
        </b-modal>

        <b-modal dialog-class="modal-pax" ref="modal_details" hide-footer>
			<template v-slot:modal-title class="d-flex">
				{{ $t('pax.detail_croisement') }}
				<button class="input-group-text px-3 modal-header-btn" @click="openIntroduction"><font-awesome-icon :icon="['fas', 'info']" /></button>
				<span class="elipsis">{{ stallion_choose.horse_nom }} X {{ mare.horse_nom }}</span>
			</template>

			<template v-if="Object.keys(stallion_choose).length > 0 && Object.keys(recap).length > 0">
				<div class="tabLine" v-for="critere in criteres_local" :key="critere.criteres_id">
					<div class="row no-gutters align-items-center" >
						<div class="col-6">
							{{ critere.critereslang_label }}
						</div>
						<div class="col text-center">
							<span class="bullet red" v-if="parseInt(recap[stallion_choose.horse_id][critere.criteres_id]) < critere.criteres_red">
							</span>
							<span class="bullet green" v-else-if="parseInt(recap[stallion_choose.horse_id][critere.criteres_id]) >= critere.criteres_green">
							</span>
							<span class="bullet orange" v-else-if="parseInt(recap[stallion_choose.horse_id][critere.criteres_id]) >= critere.criteres_red && parseInt(recap[stallion_choose.horse_id][critere.criteres_id]) < critere.criteres_green">
							</span>
							<span class="bullet grey" v-else></span>
						</div>
					</div>
				</div>

				<div class="row no-gutters tools mt-4">
					<div class="col-12 px-1">
						<a class="modal-btn" :href="'https://www.gfeweb.com/' + lang + '/?redirect_to_fiche=1&horse_nom=' + mare.horse_nom + '&horse_sire=' + mare.horse_sire " target="_blank"><span><i>{{ mare.horse_nom }}</i> <b>{{ $t('pax.voir_fiche_etalon') }}</b></span></a>
					</div>
					<div class="col-12 px-1 mt-2">
						<router-link :to="{ name: 'ContractNew', params: {stallion_id: mare.horse_id, mare_id: stallion_choose.horse_id}}" target="_blank" class="modal-btn"><span><font-awesome-icon :icon="['far', 'money-check-edit']" /><b>{{ $t('pax.reserver_en_ligne') }}</b></span></router-link>
					</div>
				</div>
			</template>
		</b-modal>

		<b-modal dialog-class="modal-pax" ref="modal_intro" hide-footer>
			<template v-slot:modal-title>
				{{ $t('pax.pax_express') }}
			</template>

			<div v-html="text_intro"></div>
		</b-modal>
	</div>
</template>

<script type="text/javascript">
    import { EventBus } from 'EventBus'
	import Navigation from "@/mixins/Navigation.js"
	import PaxMixin from "@/mixins/Pax.js"
	import Tools from "@/mixins/Tools.js";
	import _cloneDeep from 'lodash/cloneDeep';


	export default {
		name: "ResultCompatibiliteHReverse",
		props: {
			criteres: {
				type: Array,
				default: () => ( [] )
			},
			stallions: {
				type: Array,
				default: () => ( [] )
			},
			displayCompatibilite: {
				type: Boolean,
				default: () => (false)
			},
			mare: {
				type: Object,
				default: () => ( null )
			}
		},
		mixins: [Navigation, PaxMixin, Tools],
		data () {
			return {
				stallions_local: [],
				criteres_local: [],
				recap: {},
				stallions_selected: [null, null, null],
				show_note: true,
				stallions_selection_modal: [],
				stallion_choose: {},
				lang: 'fr',
				text_intro: '',
                genetic_indicators: {},
                genetic_loading: false,
				processing: true
			}
		},
		created() {
			this.init_component()
		},
		methods: {
			async init_component() {
				this.processing = true
				this.stallions_local = _cloneDeep(this.stallions)
				this.stallions_selection_modal = this.stallions_local
				this.lang = this.getConfig('lang')
				this.text_intro = this.getConfig('translations')['pax_reverse'][this.lang]

				if(this.criteres && this.criteres.length > 0) {
					this.criteres_local = _cloneDeep(this.criteres)
				}

				await this.calculCompatibilite()
				await this.calculGeneticIndicator()
				this.processing = false
			},

			async calculCompatibilite() {
				this.processing = true
				this.recap = await this.paxCalculCompatiblite(this.stallions_local, this.criteres_local)
				this.processing = false
			},

			async showCompatibilite() {
				if(this.stallions_local.length > 3) {
					this.$refs.modal.show()
					return false
				}
				this.$emit('update:step_label', "comparaison_V")
				this.$emit('update:stallions_comparaison', this.stallions_local)
				this.$emit('update:displayCompatibilite', true)
			},
			
			callColorGrade(stallion_id) {
				if(this.processing) return 'genetic-loading'
				return this.colorGrade(stallion_id, this.recap, this.criteres_local)
			},

			goToStallionSelection() {
				this.$emit('update:step_label', "stallions")
			},

			sendStallionsSelected() {
				this.$refs.modal.hide()
				this.$emit('update:step_label', "comparaison_V")
				this.$emit('update:stallions_comparaison', this.stallions_selected)
			},

			async displayDetailsCroisement(stallion) {
				this.stallion_choose = stallion
				this.$refs.modal_details.show()
			},

			openIntroduction() {
				this.$refs.modal_details.hide()
				this.$refs.modal_intro.show()
			},

            async calculGeneticIndicator() {
                // en mode inversé, mare est l'étalon sélectionné et stallions_local les juments du client
                const mares_ids = this.stallions_local.map(mare => mare.horse_id)
                if(!this.mare || mares_ids.length == 0) return false
                this.genetic_loading = true
                this.genetic_indicators = await this.getGeneticIndicatorReverse(this.mare.horse_id, mares_ids.join(','))
                this.genetic_loading = false
            },

            colorGeneticIndicator(stallion_id) {
                if(this.genetic_loading) return 'genetic-loading'
                return Object.prototype.hasOwnProperty.call(this.genetic_indicators, stallion_id) ? this.genetic_indicators[stallion_id].genetic_indicator_color : 'lightgray'
            }
		},
		watch: {
			stallions(val) {
				this.stallions_local = _cloneDeep(val)
				this.stallions_selection_modal = _cloneDeep(val)
				this.calculCompatibilite()
				this.calculGeneticIndicator()
			},
			'criteres': {
				deep: true,
				handler(val) {
					this.criteres_local = _cloneDeep(val)
					this.calculCompatibilite()
				}
			},
			'stallions_selected': {
				deep: true,
				handler(val) {
					let ids = []
					val.forEach(stallion => {
						if(stallion && stallion.horse_id) {
							ids.push(stallion.horse_id)
						}
					})
					this.stallions_selection_modal = this.stallions_local.filter(stallion => !ids.includes(stallion.horse_id))
				}
			},
			'mare': {
				deep: true,
				handler(val) {
					this.calculCompatibilite()
					this.calculGeneticIndicator()
				}
			},
			show_note(val) {
				if(val) {
					window.scrollTo({ top: 250, behavior: 'smooth' });
					// setTimeout(() => this.$refs['title-stallion'].scrollIntoView({ behavior: 'smooth' }), 1000);
				}
			}
		},
		components: {
			LoadingSpinner : () => import('GroomyRoot/components/Logos/LoadingSpinner_35')
		}
	}
</script>
